export enum WorkatoStatus {
    connected = 'connected',
    notConnected = 'notConnected',
    unavailable = 'unavailable',
    connectionError = 'connectionError',
    authorizationError = 'authorizationError',
    unknown = 'unknown'
}

export enum WorkatoActions {
    offboard = 'offboard',
    license = 'license',
    onboard = 'onboard'
}

export interface WorkatoConnection {
    authorized_at?: string | null;
    authorization_status?: string | null;
    authorization_error?: string | null;
    connection_lost_at?: string | null;
    connection_lost_reason?: string | null;
    created_at?: string | null;
    external_id?: string | null;
    folder_id?: number | null;
    id?: number | null;
    identity?: string | null;
    name?: string | null;
    parent_id?: string | null;
    provider?: string | null;
    updated_at?: Date | string | null;
}

export interface MockConnectionData {
    displayName: string;
    image: string;
    integrationMessage?: string;
    name: string;
    offboardContent?: string;
    onboardContent?: string;
}
